import * as React from 'react';
import { useSettingsContext } from '../contexts/settings';
import { useFiltersContext } from '../contexts/filters';

interface IProps {
	foundPosts: number;
}

const ResultCount = ({ foundPosts }: IProps) => {
	const settings = useSettingsContext();
	const { searchQuery } = useFiltersContext();

	const singleResultText =
		'search' === settings.layout
			? `${settings.i18n.resultFor} "${searchQuery}"`
			: settings.i18n.result;
	const multipleResultText =
		'search' === settings.layout
			? `${settings.i18n.resultsFor} "${searchQuery}"`
			: settings.i18n.results;

	if (foundPosts) {
		return (
			<div className={`pfa-result-count pfa-result-count--${settings.layout}`}>
				{foundPosts} {1 === foundPosts ? singleResultText : multipleResultText}
			</div>
		);
	}

	return <></>;
};

ResultCount.displayName = 'ResultCount';

export default ResultCount;
